import React from "react";
import { X } from "lucide-react";

const VirtualKeyboard = ({ onKeyPress, onClose }) => {
  const keys = [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
    ['A', 'Z', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
    ['Q', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'M'],
    ['W', 'X', 'C', 'V', 'B', 'N', '@', '.', '_', '-'],
  ];

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-end sm:items-center justify-center p-0 sm:p-4">
      <div className="bg-white w-full sm:max-w-2xl sm:rounded-lg overflow-hidden">
        {/* Header */}
        <div className="bg-[#007EAE] text-white px-4 py-3 flex items-center justify-between">
          <h3 className="font-semibold">Clavier virtuel sécurisé</h3>
          <button
            onClick={onClose}
            className="text-white/90 hover:text-white p-1"
            aria-label="Fermer"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Keyboard */}
        <div className="p-4 space-y-2">
          {keys.map((row, rowIndex) => (
            <div key={rowIndex} className="flex justify-center gap-1 sm:gap-2">
              {row.map((key) => (
                <button
                  key={key}
                  onClick={() => onKeyPress(key)}
                  className="w-10 h-10 sm:w-12 sm:h-12 bg-slate-100 hover:bg-slate-200 border border-slate-300 text-slate-800 font-semibold text-sm sm:text-base transition-colors active:bg-slate-300"
                >
                  {key}
                </button>
              ))}
            </div>
          ))}
          
          {/* Special keys */}
          <div className="flex justify-center gap-2 mt-3">
            <button
              onClick={() => onKeyPress('SPACE')}
              className="px-8 h-10 bg-slate-100 hover:bg-slate-200 border border-slate-300 text-slate-800 font-semibold text-sm transition-colors"
            >
              ESPACE
            </button>
            <button
              onClick={() => onKeyPress('BACKSPACE')}
              className="px-6 h-10 bg-red-100 hover:bg-red-200 border border-red-300 text-red-800 font-semibold text-sm transition-colors"
            >
              ⌫ EFFACER
            </button>
          </div>
        </div>

        <div className="px-4 pb-4">
          <p className="text-xs text-slate-500 text-center">
            Utilisez ce clavier pour une saisie sécurisée de vos identifiants
          </p>
        </div>
      </div>
    </div>
  );
};

export default VirtualKeyboard;
